import { render, staticRenderFns } from "./ListaDevoluciones.vue?vue&type=template&id=44385dc6&scoped=true"
import script from "./ListaDevoluciones.vue?vue&type=script&lang=js"
export * from "./ListaDevoluciones.vue?vue&type=script&lang=js"
import style0 from "./ListaDevoluciones.vue?vue&type=style&index=0&id=44385dc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44385dc6",
  null
  
)

export default component.exports